import React from 'react'
import { withSiteData } from 'react-static'
import Navbar from './components/Navbar'
import CallUsBanner from './components/CallUsBanner'

export default withSiteData(({signInUrl, handleClick}) => (
    <React.Fragment>
        <CallUsBanner/>
        <Navbar signInUrl={signInUrl} handleClick={handleClick}/>
    </React.Fragment>
))
